<template>
  <div>
    <v-row class="mt-12 mb-2" v-if="!openInModal">
      <v-col class="pa-0">
        <h2>{{ metaData.fileName }}</h2>
      </v-col>
    </v-row>
    <v-row class="mb-4" no-gutters justify="space-between" align="center">
      <v-col>
        <v-row>
          <div class="pa-0">
            <span class="font-600 mr-2">Accessible by : </span>
          </div>
          <div class="pa-0 w-50">
            <!-- For teams/dropbox archives -->
            <span v-if="isTeams || isDropbox">
              {{ accessibleBy }}
            </span>
            <span v-else-if="hasVersion">
              <span
                class="secondary-text font14 mr-1"
                v-for="owner in metaData.ownerIds"
                :key="owner"
              >
                {{ formatUserName(userIdNameMap[owner]) }}
              </span>
            </span>
          </div>
        </v-row>
        <v-row class="mb-2" v-if="!isTeams">
          <v-col class="pa-0">
            <span class="font-600">Synced at : </span>
            <span v-if="!metaData.lastUpdatedAt && !metaData.updatedOn"> </span>
            <span class="secondary-text font14" v-else-if="openInModal">
              {{ getFormatedDateAsPerTimeAndDate(metaData.lastUpdatedAt) }}
            </span>
            <span class="secondary-text font14" v-else>
              {{ getFormatedDateAsPerTimeAndDate(metaData.updatedOn) }}
            </span>
          </v-col>
        </v-row>
        <v-row class="mb-2" v-if="!isTeams">
          <v-col class="pa-0">
            <span class="font-600">Version : </span>
            <span v-if="hasVersion">
              <span class="secondary-text font14 mr-1">
                {{ metaData.version }}
              </span>
              <span class="secondary-text font14">{{ versionDes }}</span>
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-if="openInModal" md="2">
        <x-button
          class="w-auto"
          :buttonText="buttonText"
          @click="addToSaved"
          :color="primaryColor"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import EventBus from '@/EventBus';
export default {
  name: 'FileDetails',
  props: {
    openInModal: Boolean,
    metaData: Object,
    propsArchiveId: String,
    isTeams: Boolean,
    isDropbox: Boolean
  },
  data() {
    return {
      buttonText: 'Add to Saved Items'
    };
  },
  computed: {
    hasVersion() {
      return this.metaData?.version && this.metaData?.version !== '-';
    },
    versionDes() {
      return this.metaData?.latestVersion
        ? '( It is latest version )'
        : '( It is previous version )';
    },
    primaryColor() {
      return this.$vuetify?.theme?.themes?.light?.primary;
    },
    accessibleBy() {
      const accessibleByNames = (this.metaData.ownerIds || []).map(
        senderDetails => this.getMessageSenderName(senderDetails || {}) || ''
      );
      return accessibleByNames.join(', ');
    }
  },
  methods: {
    async addToSaved() {
      try {
        const projectId = this.$route.params.projectId;
        await this.$services.project.addArchives(projectId, {
          archives: [this.propsArchiveId],
          archiveType: this.$enums.archiveType.VAULT
        });
        this.snackbar('success', this.$message.ITEMS_SAVED);
        EventBus.$emit('REFRESH_COLLABORATORS', true);
      } catch (err) {
        this.snackbar('error', this.$message.ERROR);
      }
    }
  }
};
</script>
